<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog">Қўшиш</button>
                        <!--<div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">-->
                            <!--1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})-->
                        <!--</div>-->
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                              <div class="table-wrapper">
                                <table class="table table-striped comparison-table" :style="`min-width: ${900 + financeResult.periods.length * 130}px`">
                                    <tr>
                                        <th rowspan="2" class="w-25 text-center">Курсаткичлар номи <br/> Наименование показателя</th>
                                        <th rowspan="2" class="w-10 text-center">Сатр коди <br/> Код стр.</th>
                                        <th :colspan="index+2" class="text-center">
                                            Прогнос даври
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-center" v-for="(analog, index) in financeResult.periods" :key="index" style="position: relative" >
                                            <table class="w-100">
                                                <tr>
                                                    <th colspan="2" class="border-0">
                                                        <div class="row">
                                                            <div class="col-sm-2">
                                                                <div v-if="index===0" class="">Режа</div>
                                                            </div>
                                                            <div :class="index>0?'col-sm-12':'col-sm-10'">
                                                                <custom-date-picker
                                                                        class="form-control"
                                                                        :format="index>0?'yyyy':'dd/MM/yyyy'"
                                                                        :minimumView="index>0?'year':'day'"
                                                                        v-model="analog.startDate"
                                                                        :date="analog.startDate"
                                                                        :clear-button="true">
                                                                </custom-date-picker>
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишдан соф тушум
                                            <br/>Чистая выручка от реализации продукции (товаров, работ и услуг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['010'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['010'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сотилган маҳсулот (товар, иш ва хизмат) ларнинг таннархи
                                            <br/>Себестоимость реализованной продукции (товаров, работ и услуг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['020'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['020'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маҳсулот (товар, иш ва хизмат) ларни сотишнинг ялпи фойдаси (зарари) (сатр.010-020)<br/>
                                            Валовая прибыль (убыток) от реализации продукции (товаров, работ и услуг)  (стр.010-020)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['030'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['030'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Давр харажатлари, жами  (сатр.050+060+070), шу жумладан:<br/>
                                            Расходы периода, всего  (стр.050+060+070), в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['040'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['040'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сотиш харажатлари <br/>
                                            Расходы по реализации
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['050'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['050'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Маъмурий харажатлар <br/>
                                            Административные расходы
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['060'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['060'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа операцион харажатлар<br/>
                                            Прочие операционные расходы
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['070'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['070'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Келгусида соликка тортиладиган базадан чикариладиган хисобот даври харажатлари<br/>
                                            Расходы отчетного приода искл. из НБ в будушщем
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['080'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['080'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Асосий фаолиятнинг бошқа даромадлари<br/>
                                            Прочие доходы от основной деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['090'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['090'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Асосий фаолиятнинг фойдаси (зарари) (сатр. 030-040+090) <br/>
                                            Прибыль (убыток) от основной деятельности  (стр.030-040+090)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['100'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['100'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолиятнинг даромадлари, жами (сатр.120+130+140+150+160), шу жумладан:<br/>
                                            Доходы от финансовой деятельности, всего (стр.120+130+140+150+160), в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['110'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['110'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Дивидендлар шаклидаги даромадлар<br/>
                                            Доходы в виде дивидендов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['120'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['120'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фоизлар шаклидаги даромадлар<br/>
                                            Доходы в виде процентов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['130'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['130'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли ижара (лизинг) дан даромадлар<br/>
                                            Доходы от долгосрочной аренды (лизинг)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['140'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['140'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Валюта курси фарқидан даромадлар<br/>
                                            Доходы от валютных курсовых разниц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['150'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['150'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолиятнинг бошқа даромадлари<br/>
                                            Прочие доходы от финансовой деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['160'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['160'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолият бўйича харажатлар (сатр.180+190+200+210),  шу жумладан:<br/>
                                            Расходы по финансовой деятельности (стр.180+190+200+210),  в том числе:
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['170'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['170'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фоизлар шаклидаги харажатлар<br/>
                                            Расходы в виде процентов
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['180'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['180'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли ижара (лизинг) бўйича фоизлар шаклидаги харажатлар<br/>
                                            Расходы в виде процентов по долгосрочной аренде (лизингу)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['190'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['190'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Валюта курси фарқидан зарарлар<br/>
                                            Убытки от валютных курсовых разниц
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['200'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['200'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Молиявий фаолият бўйича бошқа харажатлар<br/>
                                            Прочие расходы по финансовой деятельности
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['210'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['210'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Умумхўжалик фаолиятининг фойдаси (зарари) (сатр.100+110-170)<br/>
                                            Прибыль (убыток) от общехозяйственной деятельности (стр.100+110-170)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['220'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['220'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фавқулоддаги фойда ва зарарлар<br/>
                                            Чрезвычайные прибыли и убытки
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['230'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['230'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Даромад (фойда) солиғини тўлагунга қадар фойда (зарар) (сатр.220+/-230)<br/>
                                            Прибыль (убыток) до уплаты налога на доходы (прибыль) (стр.220+/-230)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['240'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['240'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Даромад (фойда) солиғи<br/>
                                            Налог на доходы (прибыль)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['250'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['250'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Фойдадан бошқа солиқлар ва йиғимлар<br/>
                                            Прочие налоги и сборы от прибыли
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['260'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['260'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">ҳисобот даврининг соф фойдаси (зарари) (сатр.240-250-260)<br/>
                                            Чистая прибыль (убыток) отчетного периода (стр.240-250-260)
                                        </td>
                                        <td class="w-10 text-center">{{financeResult['270'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['270'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Амортизация</td>
                                        <td class="w-10 text-center"></td>
                                        <td class="text-center" v-for="(analog, index) in financeResult['amortization'].years" :key="index" style="position: relative">
                                            <table class="w-100 h-100" style="min-height: 100% !important;">
                                                <tr>
                                                    <td style="border: 0px">
                                                        <numeric-input v-model="analog.profit" :precision="2" align="center"/>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                              </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker';
   // import Treeselect from '@riophae/vue-treeselect';
   //  import {formatDate/*, parseDate*/} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    // import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';

    export default {
        name: "BusinessPlanView",
        components: {
            CustomDatePicker
           // Treeselect
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                businessId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                name: '',
                region: null,
                index: 0,
                financeResult: {
                    '010': {
                        code: '010',
                        years: []
                    },
                    '020': {
                        code: '020',
                        years: []
                    },
                    '030': {
                        code: '030',
                        years: []
                    },
                    '040': {
                        code: '040',
                        years: []
                    },
                    '050': {
                        code: '050',
                        years: []
                    },
                    '060': {
                        code: '060',
                        years: []
                    },
                    '070': {
                        code: '070',
                        years: []
                    },
                    '080': {
                        code: '080',
                        years: []
                    },
                    '090': {
                        code: '090',
                        years: []
                    },
                    '100': {
                        code: '100',
                        years: []
                    },
                    '110': {
                        code: '110',
                        years: []
                    },
                    '120': {
                        code: '120',
                        years: []
                    },
                    '130': {
                        code: '130',
                        years: []
                    },
                    '140': {
                        code: '140',
                        years: []
                    },
                    '150': {
                        code: '150',
                        years: []
                    },
                    '160': {
                        code: '160',
                        years: []
                    },
                    '170': {
                        code: '170',
                        years: []
                    },
                    '180': {
                        code: '180',
                        years: []
                    },
                    '190': {
                        code: '190',
                        years: []
                    },
                    '200': {
                        code: '200',
                        years: []
                    },
                    '210': {
                        code: '210',
                        years: []
                    },
                    '220': {
                        code: '220',
                        years: []
                    },
                    '230': {
                        code: '230',
                        years: []
                    },
                    '240': {
                        code: '240',
                        years: []
                    },
                    '250': {
                        code: '250',
                        years: []
                    },
                    '260': {
                        code: '260',
                        years: []
                    },
                    '270': {
                        code: '270',
                        years: []
                    },
                    'amortization': {
                        code: 'amortization',
                        years: []
                    },
                    businessId: this.businessId,
                    periods: [],
                    data: {

                    }
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                createDate: null,
                sectionResId: null,
                sectionType: null,
                maxMadeYear: new Date().getFullYear()
            }
        },
        validations() {
            return {
            }
        },
        computed: {
            // calculated() {
            //
            // },
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('asset/business-plan/' + this.businessId)
                    .then(res => {
                        if (res.data) {
                            for (const key in res.data.data) {
                                vm.financeResult[key].years = res.data.data[key];
                            }
                            vm.financeResult.periods = res.data.periods;
                            if (vm.financeResult.periods) {
                                vm.index = vm.financeResult.periods.length;
                            }
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'business/edit/' + this.businessId);
            },
            save() {
                // this.$v.$touch();
                // if (this.$v.$invalid) {
                //     return;
                // }
                this.financeResult.businessId = this.businessId;
                var years_columns = [];
                this.financeResult.periods.forEach((field) => {
                    years_columns.push({
                        startDate: field.startDate,
                        endDate: field.endDate,
                    });
                });
                this.financeResult.periods = years_columns;
                for (let key in this.financeResult) {
                    if (!(key === "businessId" || key === "periods" || key === "data")) {
                        this.financeResult.data[key] = this.financeResult[key].years;
                    }
                }
                console.log(this.financeResult);
                this.processing = true;
                this.$http.post('asset/save-business-plan', this.financeResult)
                    .then(res => {
                        console.log(res.data);
                        if (res && res.status ===200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('business.financeResult.success'),
                                type: 'success'
                            });
                            this.$router.push(this.parentName + 'business/edit/' + this.businessId);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            addAnalog() {
                if (this.index > 4) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: '5 йил киритилади',
                        type: 'warning'
                    });
                    return;
                }
                this.index += 1;
                for (const key in this.financeResult) {
                    if (!(key === "businessId" || key === "periods" || key === "data") ) {
                        this.financeResult[key].years.push({
                            profit: 0,
                            expense: 0,
                        });
                    }
                }
                if (!this.financeResult.periods){
                    this.financeResult.periods = [];
                }
                this.financeResult.periods.push({
                    startDate: null,
                    endDate: null,
                });
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
